import { Input, Directive } from '@angular/core';

import { PageService } from './page.service';

@Directive()
export class SePageComponent<TState = {}> {

    // data members

    private _state: TState;
    get state(): TState {
        return this._state;
    }
    @Input()
    set state(state: TState) {
        this.onState(state);
    }

    private _isBusy: boolean = false;
    get isBusy(): boolean {
        return this._isBusy;
    }
    @Input()
    set isBusy(isBusy: boolean) {
        this.onIsBusy(isBusy);
    }

    // constructor

    constructor(protected pageService: PageService) {
    }

    // public functions

    protected onState(state: TState) {
        this._state = state;
    }

    protected onIsBusy(isBusy: boolean) {
        this._isBusy = isBusy;
    }

    protected onBack() {

        this.pageService.headerService.clear();
        this.pageService.routerStackService.back();
    }

}
